$(document).ready(function () {  
  if (! checkout()) {
    creatingLog();
    window.location.href = '/pages/checkout-error';
    return;
  }
  if (checkout() == 'preview') {
    creatingLog();
    return;
  }
var invoiceId = invoice_id();
var subId = checkout();
var variation_id=$.session.get('variation_id');
var invoiceId = invoiceId.replace(/[{}]/g, '');
var subscriptionId = subId.replace(/[{}]/g, '');

if(invoiceId == "invoice.id" && subscriptionId=="subscription.id" && variation_id == undefined)
{
    window.location.href = "https://store.okido.com/pages/thank-you-gift-recipient";
}
  creatingLog();
  checkOrderStatus();
});

function checkOrderStatus () {  
  var variation_id=$.session.get('variation_id');
  var main_product=$.session.get('main_product');
  var personalised_message = '';
  if($.session.get('personalised_message') && $.session.get('personalised_message') !='')
  {
      personalised_message = "&personalised_message="+$.session.get('personalised_message');
  }
  $.ajax({
    xhrFields: {cors: true},
    type: 'GET',
    url: $('#chargebee').data('checkouts') + "/order.php?sub=" + checkout()+"&variation_id="+variation_id+"&invoice_id="+invoice_id()+personalised_message,
    crossDomain: true,
    success: function(response){
          var obj1 = jQuery.parseJSON(response);     
          if(obj1.status=='success'){
            if(obj1.success!=''){
                $.session.set('personalised_message', '');
                window.location.href = obj1.success;
              
            }
            else{
                $.session.set('personalised_message', '');
                window.location.href = $.session.get('main_product_url')+"?order="+obj1.order;
            }
            return false;
          }
      }
  }).always(function () { 
    setTimeout(checkOrderStatus, 3000);
  });
}
function creatingLog()
{
 let checkout_url =  window.location;
  $.ajax({
      xhrFields: {cors: true},
      type: 'GET',
      url: $('#chargebee').data('checkouts') + "/log.php?checkout_url=" + encodeURIComponent(checkout_url),
      crossDomain: true,
      success: function(response){
          
        }
  });
}

function reportError (error) {
  alert('Error completing order. Please contact customer support.');
}

function checkout () {
  var query = new URLSearchParams(window.location.search);

  if (query.has('sub_id')) {
    query.set('checkout', query.get('sub_id'));
  }

  return query.get('checkout');
}

function invoice_id () {
  var query = new URLSearchParams(window.location.search);

  if (query.has('invoice_id')) {
    query.set('invoice_id', query.get('invoice_id'));
  }

  return query.get('invoice_id');
}